<template>
    <div class="request__chat">
        <app-container-loading :show="isLoading" text="Carregando chat..."></app-container-loading>
        <div class="chat__container" v-if="getResponsibleUser">
            <div class="chat__left-column">
                <div class="current-responsible">
                    <img class="current-responsible__avatar" 
                        :src="getResponsibleUser.avatarUrl 
                            ? getResponsibleUser.avatarUrl 
                            : require('../../../../../assets/imgs/default-avatar.png')" 
                        :onerror="`this.onerror=null;this.src='${require('../../../../../assets/imgs/default-avatar.png')}';`"
                        alt="Avatar do usuário responsavel no chat"
                    />
                    <div class="current-responsible__details">
                        <h3>{{ getResponsibleUser.name }}</h3>
                        <span>{{ isOnline ? 'online' : 'offline' }}</span>
                    </div>
                </div>
                <div class="canned-messages">
                    <div class="canned-messages__title">
                        <span>Copiar para o chat</span>
                        <icon name="reply-all" />
                    </div>
                    <ul class="canned-messages__body">
                        <li><a href="javascript:void(0)" @click="sendDefaultMessage('Já recebi o pagamento')">Já recebi o pagamento</a></li>
                        <li><a href="javascript:void(0)" @click="sendDefaultMessage('Tem urgência')">Tem urgência</a></li>
                        <li><a href="javascript:void(0)" @click="sendDefaultMessage('Interfone quebrado')">Interfone quebrado</a></li>
                        <li><a href="javascript:void(0)" @click="sendDefaultMessage('O cliente vai sair logo')">O cliente vai sair logo</a></li>
                        <li><a href="javascript:void(0)" @click="sendDefaultMessage('Ligar antes de ir')">Ligar antes de ir</a></li>
                    </ul>
                </div>
            </div>
            <div class="chat__right-column" v-if="chatLoaded">
                <app-perfect-scrollbar class="scrollbar">
                    <div class="chat__area">
                        <ul :id="'messages-' + request.id">
                            <li v-for="(chatItem, index) of getChatItems" :key="index" 
                                class="chat-message" 
                                :class="{ 
                                    'chat-message--me': chatItem.userId == user.id, 
                                    'chat-message--others': chatItem.userId != user.id 
                                }"
                            >
                                <div class="chat-message__body" v-if="chatItem.type === 'text'">
                                    <img v-if="chatItem.userId != user.id" 
                                        class="body__avatar" 
                                        :src="getUserById(chatItem.userId).avatarUrl ? getUserById(chatItem.userId).avatarUrl : require('../../../../../assets/imgs/default-avatar.png')"
                                        :onerror="`this.onerror=null;this.src='${require('../../../../../assets/imgs/default-avatar.png')}';`" 
                                    />
                                    <div v-if="chatItem.error" class="chat-message__warning" @click="retrySendMessage(chatItem)">
                                        <icon name="warning" color="#E0634A"/>
                                    </div>
                                    <div class="body__content">
                                        <div class="body__user-name" v-show="chatItem.userId != user.id">
                                            <span>
                                                {{ getUserById(chatItem.userId) ? utils.toTitleizeString(getUserById(chatItem.userId).name) : '' }}
                                            </span>
                                        </div>
                                        <span>{{ chatItem.data }}</span>
                                        <div class="content__detail">
                                            <small style="margin-right:3px;">{{ moment(chatItem.dateCreated).local().format('HH:mm') }}</small>
                                            <div v-if="(chatItem.userId == user.id || chatItem.responsibleUserId == request.STATE_request.responsibleUserIdPersisted) && chatItem.userId != request.STATE_request.responsibleUserIdPersisted" >
                                                <icon v-if="chatItem.status === 'sent'" name="check" />
                                                <icon v-else-if="chatItem.status === 'read'" name="double-check" color="#58BFC6"/>
                                                <icon v-else-if="chatItem.status === 'received'" name="double-check" />
                                                <icon v-else-if="chatItem.status === 'pending'" name="timer" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </app-perfect-scrollbar>
                <div class="input__area">
                    <app-emoji-picker @selectEmoji="selectEmoji($event)">
                        <a href="javascript:void(0)">
                            <icon name="emoji" width="24" height="24" hoverColor="#4d76c8" />
                        </a>
                        <template slot="content">
                        </template>
                    </app-emoji-picker>
                    <textarea-autosize style="font-size: 1em" v-model="textareaValue" @keydown.native.prevent.enter="sendMessage(textareaValue)" :min-height="22" :max-height="60"></textarea-autosize>
                    <div class="input__button-send" @click="sendMessage(textareaValue)">
                        <icon name="send" :width="30" :height="30" hoverColor="#4d76c8" />
                    </div>
                </div>
            </div>
            <div class="chat__right-column" v-else>
                <div class="chat__area">
                    <ul id="messages">
                        <li class="chat-message--others">
                            <div class="chat-message__body">
                                <div class="body__content">
                                    Não foi possível carregar o chat do pedido :/
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapMutations, mapState, mapActions } from 'vuex'
    import _ from 'lodash'
    import Vue from 'vue'
    import shortid from 'shortid'
    import moment from 'moment'

    import ContactAPI from '../../../../../api/contacts'
    import RequestsAPI from '../../../../../api/requests'

    import EmojiPickerComponent from '../../../../..//components/Inputs/EmojiPicker/EmojiPicker.vue'

    export default {
        props: ['request'],
        mixins: [],
        components: {
            'app-emoji-picker': EmojiPickerComponent
        },
        data(){
            return {
                isLoading: false,
                textareaValue: '',
                isOnline: false,
                responsibleUser: null,
                chatItems: [],
                timeoutDefaultMessage: null,
                timeoutToSendMessage: null,
                showEmojiPicker: false,
                chatLoaded: false,
            }
        },
        computed: {
            ...mapState('auth', ['user']),
            getResponsibleUser() {
                return this.VXORM.User.find(this.request.STATE_request.responsibleUserIdPersisted)
            },

            getChatItems() {
                return this.chatItems
            }
        },
        methods: {
            ...mapActions("toast", ["showToast", "showError"]),
            sendMessage(message, type = 'text'){
                if(message.trim() == '') return
                const index = this.chatItems.push({
                    type: 'text',
                    data: message,
                    status: 'pending',
                    userId: this.user.id
                })

                let data = message
                const currentChatItem = this.chatItems[index - 1]
                this.textareaValue = ''

                this.scrollToBottom()

                if(this.timeoutToSendMessage)
                    this.timeoutToSendMessage = setTimeout(() => {
                        const response = this.__trySendChatItem(type, data, currentChatItem, 0)
                        response.then(() => this.timeoutToSendMessage = null)
                    }, 500)
                else 
                    this.__trySendChatItem(type, data, currentChatItem, 0)
            },

            retrySendMessage(chatItem, index) {
                _.assign(chatItem, { error: null })
                this.__trySendChatItem(chatItem.type, chatItem.data, chatItem, 0)
            },

            sendDefaultMessage(message) {
                if(!this.timeoutDefaultMessage) {
                    const index = this.chatItems.push({
                        type: 'text',
                        data: message,
                        status: 'pending',
                        userId: this.user.id
                    })

                    this.scrollToBottom()
                    this.__trySendChatItem('text', message, this.chatItems[index - 1], 0)

                    this.timeoutDefaultMessage = setTimeout(() => {
                        this.timeoutDefaultMessage = null
                    }, 10000)
                }
            },

            __trySendChatItem(type, data, currentChatItem, retries) {
                return RequestsAPI.createRequestChatItem(this.request.id,{
                    type,
                    data,
                    responsibleUserId: this.request.STATE_request.responsibleUserIdPersisted
                }).then(res => {
                    _.assign(currentChatItem, { id: res.data.id, status: 'sent', error: null })
                    return 'ok'
                }).catch(error => {
                    if(retries >= 15) {
                        console.error(error)
                        return _.assign(currentChatItem, { error })
                    }

                    setTimeout(() => {
                        retries++
                        return this.__trySendChatItem(type, data, currentChatItem, retries)
                    }, 5000)
                })
            },

            getUserById(userId) {
                return this.VXORM.User.find(userId)
            },

            scrollToBottom() {
                setTimeout(() => document.querySelector('#messages-' + this.request.id).scrollIntoView({ block: 'end' }), 100)
            },

            selectEmoji(emoji) {
                this.textareaValue = this.textareaValue + emoji.char
            },
            _reconnectEv(ev) {
                this.__emitPresenceRequestChatRoom(true)
            },

            __handleSocketEvents() {
                this.$socket.on('reconnect', this._reconnectEv)
                this.$socket.on('presence-request-chat-room', this._presenceRequestChatRoomEv)
                this.$socket.on('request-chat', this._requestChatEv)
            },

            _presenceRequestChatRoomEv(ev) {
                if(ev.op === 'add') 
                    ev.data.userIds.forEach(userId => {
                        if(userId == this.request.STATE_request.responsibleUserIdPersisted && this.request.id == ev.data.requestId) this.isOnline = true
                    })
                else 
                    if(ev.data.userId == this.request.STATE_request.responsibleUserIdPersisted && this.request.id == ev.data.requestId) this.isOnline = false
            },

            _requestChatEv(ev) {
                if(ev.op === 'created') {
                    if(ev.data.userId != this.user.id && this.request.id == ev.requestId) {
                        RequestsAPI.markChatItemsStatus(this.request.id, {
                            reads: [ev.data.id],
                            receiveds: [ev.data.id]
                        })
                            .catch(err => console.error(err))
                            
                        this.chatItems.push(_.assign(ev.data, { status: 'sent' }))
                        this.scrollToBottom()
                    }
                }
                else if(ev.op === 'updated' && this.request.id == ev.requestId) {
                    const _chatItemReads = ev.data.chatItemReads
                    const _chatItemReceiveds = ev.data.chatItemReceiveds
                    _chatItemReceiveds.forEach(_chatItemReceived =>
                        _.assign(this.chatItems.find(chatItem => chatItem.id == _chatItemReceived.chatItemId 
                            && _chatItemReceived.userId == this.request.STATE_request.responsibleUserIdPersisted), { status: 'received' }))
                    _chatItemReads.forEach(_chatItemRead => 
                        _.assign(this.chatItems.find(chatItem => chatItem.id == _chatItemRead.chatItemId
                            && _chatItemRead.userId == this.request.STATE_request.responsibleUserIdPersisted), { status: 'read' }))
                }
            },

            __emitPresenceRequestChatRoom(open) {
                this.$socket.emit('presence-request-chat-room', { 
                    open,
                    userId: this.user.id, 
                    requestId: this.request.id, 
                    companyId: this.user.defaultCompanyId 
                })
            },

        },
        async mounted(){
            this.isLoading = true
            try {
                const res = await RequestsAPI.getRequestChatItems(this.request.id)
                const _chatItems = res.data
                _chatItems.forEach(_chatItem => {
                    this.chatItems.push({ 
                        ..._.omit(_chatItem, ['chatItemReads', 'chatItemReceiveds']), 
                        status: (() => {
                            let status = 'sent'
                            const responsibleUserReceived = _chatItem.chatItemReceiveds.find(_chatItemReceived => 
                                _chatItemReceived.userId == this.request.STATE_request.responsibleUserIdPersisted) 
                            const responsibleUserRead = _chatItem.chatItemReads.find(_chatItemRead => 
                                _chatItemRead.userId == this.request.STATE_request.responsibleUserIdPersisted) 
                            
                            if(responsibleUserReceived) status = 'received'
                            if(responsibleUserRead) status = 'read'
                            return status
                        })()
                    })
                })

                this.chatLoaded = true
                this.scrollToBottom()
                this.__handleSocketEvents()
                
                this.__emitPresenceRequestChatRoom(true)
            }
            catch(err) {
                console.error(err)
                this.chatLoaded = false
            }
            this.isLoading = false
        },
        beforeDestroy() {
            this.__emitPresenceRequestChatRoom(false)
            this.$socket.off('presence-request-chat-room', this._presenceRequestChatRoomEv)
            this.$socket.off('request-chat', this._requestChatEv)
            this.$socket.off('reconnect', this._reconnectEv)
        }
    }
</script>

<style lang="scss" scoped>
    .request__chat {
        margin-bottom: 10px;
        width: 100%;
        .chat__container { 
            width: 100%; 
            height: 100%;
            display: flex;
            flex-direction: row;
            background-color: #31363C;
            border-bottom-right-radius: 5px;
            border-bottom-left-radius: 5px;
            .chat__left-column {
                width: 220px;
                background-color: #2A2E33;
                border-bottom-left-radius: 5px;
                .current-responsible {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding: 20px 15px;
                    border-bottom: 1px solid rgba(0,0,0,.2);
                    margin-bottom: 20px;
                    .current-responsible__avatar {
                        width: 36px;
                        height: 36px;
                        border-radius: 50%;
                        border: 1px solid #FFF;
                        margin-right: 10px;
                    }
                    h3 {
                        font-size: 16px;
                        color: #C3C5C6;
                    }
                }
                .canned-messages {
                    display: flex;
                    flex-direction: column;
                    padding: 0 13px 15px 13px;
                    .canned-messages__title {
                        display: flex;
                        flex-direction: row;
                        margin-bottom: 10px;
                        span {
                            margin-right: 5px;
                        }
                    }
                    ul.canned-messages__body{
                        li {
                            display: flex;
                            margin-bottom: 10px;
                        }
                        li a {
                            background: #373C42;
                            color: #C3C5C6;
                            border-radius: 10px;
                            padding: 5px 12px;
                            font-size: 14px;
                        }
                    }
                }
            }
            .chat__right-column {
                padding: 15px 0 15px 15px;
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                .scrollbar { 
                    flex-grow: 1;
                }
                .chat__area {
                    display: flex;
                    flex-direction: column;
                    flex-grow: 1;
                    max-height: 0;
                    li.chat-message {
                        display: flex;
                        padding: 10px;
                        &.chat-message--me {
                            justify-content: flex-end;
                            .chat-message__body .body__content {
                                background-color: #373C42;
                            }
                        }
                        &.chat-message--others {
                            justify-content: flex-start;
                            img.body__avatar {
                                margin-right: 10px;
                                border-radius: 50%;
                                width: 36px;
                                height: 36px;
                                border: 1px solid #FFF;
                            }
                            .chat-message__body .body__content {
                                background-color: #23272B;
                            }
                        }
                        .chat-message__body {
                            display: flex;
                            align-items: center;
                            padding-right: 15px;
                            .body__content {
                                padding: 5px 60px 5px 10px;
                                border-radius: 5px;
                                max-width: 320px;
                                position: relative;
                                span {
                                    color: #C3C5C6;
                                }
                                .content__detail {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;
                                    position: absolute;
                                    right: 5px;
                                    bottom: 2px;
                                    font-size: 12px;
                                    font-weight: 600;
                                }
                            }

                            .chat-message__warning {
                                width: 40px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                cursor: pointer;
                            }
                        }
                    }
                }
                .input__area {
                    background: #23272B;
                    border-radius: 5px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding: 8px;
                    margin-top: 15px;
                    margin-right: 15px;
                    textarea {
                        font-family: Arial, Helvetica, sans-serif;
                        width: 100%;
                        background: transparent;
                        border: 0;
                        outline: none;
                        padding-left: 8px;
                        margin-top: 2px;
                        color: #C3C5C6;
                        overflow: hidden;
                        resize: none;
                    }

                    .input__button-send {
                        width: 30px; 
                        display: flex; 
                        justify-content: center;
                        cursor: pointer;
                    }
                }
            }
        }

        .body__user-name span {
            font-size: .8em;
            color: #63666B;
            opacity: .5;
        }
    }
</style>
